import { DatatableRepository } from './DatatableRepository'
import { observable, action } from 'mobx'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'

export class DatatableController extends ControllerStoreBase {
    @observable datatable = {}
    interfaceName = 'crudModel.pesquisar'

    static getInstance () {
      return super.construct(new DatatableController())
    }

    @action async fetchDatatable () {
      this.datatable = await DatatableRepository.fetchDatatable(this.interfaceName)
    }
}
